// extracted by mini-css-extract-plugin
export default {"root":"PageSection_root__AB+7E","inner":"PageSection_inner__ukCgq","title":"PageSection_title__DGWgn","compact":"PageSection_compact__JdGac","center":"PageSection_center__rdpXb"};